import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import PresetNumber from '../components/PresetNumber';
import get from 'lodash/get'
import {onAssignPresetNumber} from '../actions/PresetActions';

@connect(state => ({
    presets: state.presets.items,
    selectedPresetNumber: get(state, 'form.presetNumber.values.presetNumber', null),
}), {onAssignPresetNumber})
export default class PresetNumberContainer extends Component {
    static propTypes = {
        preset: PropTypes.object,
        presetId: PropTypes.number,
        selectedPresetNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        presets: PropTypes.object,
        onAssignPresetNumber: PropTypes.func,
        onCancel: PropTypes.func,
        onSubmit: PropTypes.func,
        editableName: PropTypes.bool,
        showMatchingWarning: PropTypes.bool,
    };

    handleSubmit = (data) => {
        this.props.onAssignPresetNumber(data);
        if (this.props.onSubmit) {
            this.props.onSubmit(data);
        }
    };

    render() {
        const {presets, presetId, onCancel, editableName, selectedPresetNumber, showMatchingWarning} = this.props;
        const preset = this.props.preset || presets[presetId];
        return (
            <PresetNumber
                onSubmit={this.handleSubmit}
                presets={presets}
                initialValues={{...preset, presetNumber: `${preset.presetNumber || ''}`}}
                onCancel={onCancel}
                editableName={editableName}
                selectedPresetNumber={parseInt(selectedPresetNumber, 10)}
                showMatchingWarning={showMatchingWarning}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PresetNumberContainer.js